<template>
  <span>
    <b-switch v-model="form.value" type="is-info" @input="save"></b-switch>

    <b-loading :is-full-page="false" :active="form.processing"></b-loading>
  </span>
</template>

<script>
export default {
  props: {
    setting: String,
    value: Boolean,
    reverse: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      form: new window.Form({
        key: this.setting,
        value: this.reverse ? !this.value : this.value
      })
    };
  },

  watch: {
    value(value) {
      this.form.value = value;
    }
  },

  methods: {
    save() {
      this.form
        .put("/admin/api/settings", {
          value: this.reverse ? !this.form.value : this.form.value
        })
        .then(({ message }) => {
          this.$buefy.toast.open(message);

          this.$emit("input", this.form.value);
        });
    }
  }
};
</script>
